import { Helmet } from 'react-helmet-async';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';

const Page = forwardRef(({ children, title = '', meta, list, ...other }, ref) => (
  <>
    <Helmet>
      <title>{`${title} | LCDD`}</title>
      {meta}
    </Helmet>

    <Box ref={ref} {...other} sx={{ paddingBottom: list ? '0px' : '50px' }}>
      {children}
    </Box>
  </>
));

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  meta: PropTypes.node,
};

export default Page;